/* eslint-disable */
import React from "react";

const ChallengeLearnMoreBox = ({ setInfoModalOpen }) => {
  return (
    <div className="challenge-how-it-works-box">
      <h3 style={{ color: "#101828", fontWeight: "600" }}>HOW IT WORKS</h3>
      <div
        style={{
          fontSize: "20px",
          fontWeight: "400",
          marginBottom: "20px",
          width: "75%",
          lineHeight: "24px",
        }}
      >
        Play anytime. Post scores. Compete on a virtual leaderboard.
      </div>
      <ol
        className="numbered-list"
        style={{ color: "#475467", fontWeight: "500" }}
      >
        <li>Join a Challenge and post scores</li>
        <li>Your net scores will count towards the Challenge</li>
        <li>Post 3+ scores to qualify for the leaderboard</li>
      </ol>
      <div className="join-button-container">
        <button
          className="lnk white color-focus"
          onClick={() => {
            setInfoModalOpen(true);
          }}
          style={{
            textAlign: "center",
            fontSize: "16px",
            color: "#00365F",
            fontWeight: "550",
            background: "white",
            fontFamily: "National",
            border: "none",
            cursor: "pointer",
          }}
        >
          LEARN MORE
        </button>
      </div>
    </div>
  );
};

export default ChallengeLearnMoreBox;
